/*
    Copyright (C) Paul B. Lucas 2025, 2026  ALL RIGHTS RESERVED
    Licensed to the University of Illinois Urbana Champaign

    This is a Javascript composable that uses the assets API endpoint to fetch and store assets
    from/to the database.   Three methods are incuded:

        fetchAssetsOnOrgs -     selects assets based on a list of provided org codes
        fetchAssetsOnQuery -    selects assets based on a generalized query array of 
                                key:value pairs.
        saveAssete -            saves a single asset to database
    

    The fetchs are async functions that awaits a results of an axios call to the RWA API. When promise 
    is resolved, the results are returned in agreements ref.

    API configuration data is stored as JSON file in src/configuration/ and imported as a JSON array.  Import
    can do this from a basic JSON file.  Parameters in the config array include the base-url, the POSTQL ccf
    endpoint, and authentication data for the axios headers (API key).  Details:

        {
            "apim-key-name":    "Bearer",
            "apim-key":         "--- some key ---",
            "base-url":         "https://api.elam.fs.illinois.edu",
            "ccfURL":           "https://api.elam.fs.illinois.edu/ccf",
            "agreement-path":   "/agreements",
            "employee-path":    "/employees",
            "table-path":       "/tables",
            "assets-path":      "/assets",
            "nans":             "/nans",
            "image-url":        "/https://images.elam.fs.illinois.edu/employees/"     
        }     
        
    If the API URL changes in DNS, this file must be modified.

    <Revision History>
        02/25/2025      pblucas     created
        03/16/2026      pblucas     Corrected typos & updated copyright

        
    </Revision History>
*/


const useDateHelpers = () =>    {

     const  makePrettyDate = (date)  =>  {
    
        // converts an ISO date (YYYY-MM-DDTHH:MM:sSS.SSSZ) to human readable
        let niceDate = ""

        if(date == "") return niceDate;

        // local name array
        const aMonths = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
        // construct new date object from ISO string
        let dt = new Date(date)
        niceDate += aMonths[dt.getMonth()]+' '
        niceDate += dt.getDate()+', '
        niceDate += dt.getFullYear()

        return niceDate;

    }   // end function
    
    return {makePrettyDate}
}

export default useDateHelpers